import { Component, EventEmitter, Input, Output } from '@angular/core';
import { pageAnimation } from '@app/shared/animations/page-animations';
import { Device } from '@app/shared/models/device';

@Component({
  selector: 'app-smash-image',
  templateUrl: './smash-image.component.html',
  styleUrls: ['./smash-image.component.scss'],
  animations: [
    pageAnimation
  ]
})
export class SmashImageComponent {

  @Input() url: string;
  @Input() type: string;
  @Input() device: Device;
  @Output() imageReadyEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() imageLoadError: EventEmitter<boolean> = new EventEmitter();
  imageIsReady = false;

  constructor() { }

  imageReady($event) {
    this.imageReadyEvent.emit(true);
    this.imageIsReady = true;
  }

  imageError($event) {
    this.imageLoadError.emit(true);
  }
}
